<h1 mat-dialog-title>Invitation Link</h1>
<div mat-dialog-content>
    <div class="flex row well primary">
        <mat-icon>information</mat-icon>
        <span>Send this link to anyone you want to invite to your workspace</span>
    </div>
    <form>
        <div class="flex row">
            <mat-form-field class="flex-100">
                <mat-label>Invitation Link</mat-label>
                <input matInput [value]="data" />
            </mat-form-field>
            <button mat-icon-button (click)="copyToken()">
                <mat-icon>content_copy</mat-icon>
            </button>
        </div>
    </form>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</div>
